module.exports = __webpack_public_path__ + "img/shipo-banner-certificate-bg.1892add2.svg";